import { HashRouter, Switch, Route } from 'react-router-dom';

import { CampaignPreviewContainer } from './components/CampaignPreviewContainer.jsx';
import { CampaignPreviewTileView } from './components/CampaignPreviewTileView.jsx';

export const CampaignPreviewRouting = () => {
  return (
    <HashRouter hashType="noslash">
      <Switch>
        <Route
          path="/tile/:tileId"
          render={({ match: { params } }) => {
            // The campaign uuid lives in the page path (/campaign_previews/:uuid),
            // not in the hash route, so read it from there like the root route.
            const campaignId = window.location.pathname.split('/')[2];

            return (
              <>
                <CampaignPreviewTileView
                  tileId={params.tileId}
                  campaignId={campaignId}
                />
              </>
            );
          }}
        />

        <Route
          path="/"
          render={() => {
            const pathSegments = window.location.pathname.split('/');
            const campaignId = pathSegments[2];

            return (
              <>
                <CampaignPreviewContainer id={campaignId} />
              </>
            );
          }}
        />
      </Switch>
    </HashRouter>
  );
};
